import { cn } from '../../lib/cn';

export type PillTone = 'blue' | 'green' | 'amber' | 'red' | 'violet' | 'slate';

// Pour `amber`, on n'utilise PAS `text-warning` (#F59E0B amber-500) parce
// que le contraste sur fond rgba(245,158,11,0.12) ≈ pêche pâle est borderline
// WCAG. On force un amber-700 (#B45309) en texte qui passe AA confortablement.
export const TONE_STYLES: Record<PillTone, string> = {
  blue: 'bg-brand-soft text-brand',
  green: 'bg-[rgba(18,184,134,0.12)] text-success',
  amber: 'bg-[rgba(245,158,11,0.12)] text-[#B45309]',
  red: 'bg-[rgba(239,68,68,0.12)] text-danger',
  violet: 'bg-[rgba(124,92,255,0.12)] text-violet',
  slate: 'bg-surface-alt text-ink-soft',
};

interface PillProps {
  tone?: PillTone;
  children: React.ReactNode;
  className?: string;
}

export function Pill({ tone = 'slate', children, className }: PillProps) {
  return (
    <span
      className={cn(
        // Géométrie du 07/09/2026, en deux passes. D'abord resserrée (« les
        // badges sont encore trop gros ») : hauteur FIXE de 18 px avec
        // `leading-none`, parce que c'était le `line-height` de 16 px du cran
        // qui tenait la hauteur à 20 px — pas le padding, déjà à 2 px.
        // Puis aérée (« les libellés sont trop collés au badge ») : police au
        // cran `nano` (10 px) pour financer un padding de 10 px sans que la
        // pastille regrossisse. `items-center` recentre le glyphe dans la
        // boîte, donc aucun descendeur n'est coupé.
        'inline-flex items-center gap-1.5 px-2.5 h-[18px] rounded-full text-nano font-semibold leading-none whitespace-nowrap',
        TONE_STYLES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
